import { render, staticRenderFns } from "./SearchFormButton.vue?vue&type=template&id=04b5f1ab"
import script from "./SearchFormButton.vue?vue&type=script&lang=js"
export * from "./SearchFormButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports